import { IColor } from 'interfaces/package';
import { IReduxColor } from 'interfaces/vehicle';

export function parseColorData(color: IColor) {
  return {
    internalCode: color.manufacturingCode || color.code,
    code: color.code,
    colorIdentifier: color.id,
    name: color.name,
    enName: color.enName,
    price: color.deltaPrice ? parseInt(color.deltaPrice, 10) : 0,
    image: color.image,
  } as IReduxColor;
}
